import React, { useState } from 'react';
import { ICardLayout } from '../../types/layout/card';
import CardTitle from './title';

function Card(props: React.PropsWithChildren<ICardLayout>) {
    const {
        bodyClassName, children, className, collapsable,
        collapsed: prdefinedCollapsed, header, height, title,
    } = props;

    const [collapsed, setCollapsed] = useState(!!prdefinedCollapsed);

    const onCollapseClick = () => setCollapsed(!collapsed);

    const cardClasses = ['card card-outline'];

    if (typeof className === 'string') {
        cardClasses.push(className);
    }

    if (prdefinedCollapsed) {
        cardClasses.push('collapsed-card');
    }

    // t.match(/{(.*?)}/g)

    return (
        <div className={cardClasses.join(' ')}>
            <div className="card-header" hidden={typeof title === 'undefined' && !collapsable}>
                <CardTitle {...props} />
                {typeof header === 'string' && (
                    <div className={typeof title === 'string' ? 'd-inline ml-2' : 'd-inline'} dangerouslySetInnerHTML={{ __html: header }} />
                )}
                <div className="card-tools">
                    <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="collapse"
                        hidden={!collapsable}
                        onClick={onCollapseClick}
                    >
                        <i className={['fas', collapsed ? 'fa-plus' : 'fa-minus'].join(' ')} />
                    </button>
                </div>
            </div>
            <div className={`card-body${typeof bodyClassName === 'string' ? ` ${bodyClassName}` : ''}`} style={{ maxHeight: height, overflow: typeof height === 'number' ? 'auto' : undefined }}>
                {children}
            </div>
        </div>
    );
}

export default Card;
